// source: mlmbox/type/agent.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.mlmbox.type.Agent', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.type.Agent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.type.Agent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.type.Agent.displayName = 'proto.mlmbox.type.Agent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.type.Agent.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.type.Agent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.type.Agent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Agent.toObject = function(includeInstance, msg) {
  var f, obj = {
    bot: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    mobile: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    browserName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    browserVersion: jspb.Message.getFieldWithDefault(msg, 4, ""),
    platform: jspb.Message.getFieldWithDefault(msg, 5, ""),
    osName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    osVersion: jspb.Message.getFieldWithDefault(msg, 7, ""),
    engineName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    engineVersion: jspb.Message.getFieldWithDefault(msg, 9, ""),
    localization: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.type.Agent}
 */
proto.mlmbox.type.Agent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.type.Agent;
  return proto.mlmbox.type.Agent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.type.Agent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.type.Agent}
 */
proto.mlmbox.type.Agent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBot(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMobile(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrowserVersion(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatform(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOsName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOsVersion(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEngineName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEngineVersion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.type.Agent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.type.Agent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.type.Agent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.type.Agent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBot();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMobile();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBrowserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBrowserVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlatform();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOsName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOsVersion();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEngineName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEngineVersion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLocalization();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional bool bot = 1;
 * @return {boolean}
 */
proto.mlmbox.type.Agent.prototype.getBot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setBot = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool mobile = 2;
 * @return {boolean}
 */
proto.mlmbox.type.Agent.prototype.getMobile = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setMobile = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string browser_name = 3;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getBrowserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setBrowserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string browser_version = 4;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getBrowserVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setBrowserVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string platform = 5;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getPlatform = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string os_name = 6;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getOsName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setOsName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string os_version = 7;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getOsVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setOsVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string engine_name = 8;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getEngineName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setEngineName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string engine_version = 9;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getEngineVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setEngineVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string localization = 10;
 * @return {string}
 */
proto.mlmbox.type.Agent.prototype.getLocalization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.type.Agent} returns this
 */
proto.mlmbox.type.Agent.prototype.setLocalization = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


goog.object.extend(exports, proto.mlmbox.type);
